import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild,OnDestroy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ButtonType } from '@ascschool/interface/setting';
import { Province } from '@ascschool/model/category/province.model';
import { CommonFilter } from '@ascschool/model/commonfilter/commonfilter';
import { AuthQuery } from '@ascschool/core/auth/auth.query';
import { AuthService } from '@ascschool/core/auth/auth.service';
import { SizePageService } from '@ascschool/project/size-page/size-page.service';
import { DistrictService } from '@ascschool/services/category/district.service';
import { ProvinceService } from '@ascschool/services/category/province.service';
import { UtilsService } from '@ascschool/services/utils.service';
import { ShortcutInput } from 'ng-keyboard-shortcuts';
import { Observable ,Subject} from 'rxjs';
import { map,takeUntil } from 'rxjs/operators';
import { NzTableComponent } from 'ng-zorro-antd/table';
import { BaocaoKsnktService } from '@ascschool/services/baocao/baocao.ksnkt.service';
import { WardService } from '@ascschool/services/category/ward.service';
import { TypeOfDisabilityService } from '@ascschool/services/category/typeofdisability.service';

@Component({
  selector: 'ksnkt-dang-tat-tuoi',
  templateUrl: './ksnkt-dang-tat-tuoi.component.html',
  styleUrls: ['./ksnkt-dang-tat-tuoi.component.scss']
})
export class KsnktDangTatTuoiComponent implements OnInit,OnDestroy {
  constructor(
    private cdRef: ChangeDetectorRef, public _authService: AuthService, public sizePageService: SizePageService,
    private authQuery: AuthQuery, public utilService: UtilsService, private service: BaocaoKsnktService,
    private disProvincesService: ProvinceService, private districtService: DistrictService,
    private wardService: WardService, private typeOfDisabilityService: TypeOfDisabilityService) {
      this.currentUser = JSON.parse(localStorage.getItem('userSetting'));
     }
  get breadcrumbs(): string[] {
    return ['Báo cáo khảo sát NKT'];
  }
  // tslint:disable-next-line: adjacent-overload-signatures
  @ViewChild('pageHeaderTable', { static: false }) set content(content: ElementRef) {
    if (content) {
      // initially setter gets called with undefined
      this.elementPageHeaderTable = content;
    }
  }
  $unSubcsribe = new Subject();
  buttonTypeEnum = ButtonType;
  btnType: ButtonType;
  shortcuts: ShortcutInput[] = [];
  commonFilter = new CommonFilter();
  searchTerm = '';
  province = new Province();
  loading = true;
  width: number;
  numberControl: number;
  currentUser: any;
  isDisabled : boolean = false;
  isDisabled1 : boolean = false;
  isDisabled2 : boolean = false;
  private elementPageHeaderTable: ElementRef;
  @ViewChild('pageOptionBtnGroup', { static: false }) elementpageOptionBtnGroup: ElementRef;
  @ViewChild('pageSearch', { static: false }) elementPageSearch: ElementRef;
  @ViewChild('Table', { static: false }) tableElement: NzTableComponent;
  show = false; maxHeight: number; height: number; heightPopup: number; heightPagnagation = 50; isCollapse = true; year = '';
  getDisProvincesACFn: (value: any) => Observable<any>; DisProvincesSubscription: any; DisProvincesControl = new FormControl();
  getDistrictACFn: (value: any) => Observable<any>; DistrictSubscription: any; DistrictControl = new FormControl();
  getWardACFn: (value: any) => Observable<any>; WardSubscription: any; WardControl = new FormControl();
  getTypeOfDisabilityACFn: (value: any) => Observable<any>; TypeOfDisabilitySubscription: any; TypeOfDisabilityControl = new FormControl();
  dataTable: any = []; dataHeader1: any = []; keyIdArr: any = [];
  sortNameFn = (a: Province, b: Province) => a.provinceName.localeCompare(b.provinceName);

  ngOnInit() {
    if(this.currentUser.accountType === 3){
      this.isDisabled = true;
    }else if(this.currentUser.accountType === 1){
      this.isDisabled1 = true;
    }else if(this.currentUser.accountType === 2){
      this.isDisabled2 = true;
    }
    if (this.currentUser.accountType === 3) {
      this.commonFilter.ProvinceId = this.currentUser.provinceId;
    }
    if (this.currentUser.accountType === 3) {
      this.disProvincesService.getSelectPagingProvinceById(this.currentUser.provinceId).subscribe(res => {
        this.DisProvincesControl.setValue({ id: res.id, text: res.provinceName });
       
        //Quận huyện
        this.getDistrictACFn = (value: any) => this.districtService.getDistrictSelectPaging({
          searchTerm: value, ProvinceId: this.currentUser.provinceId, PageIndex: 1, PageSize: 100
        }).pipe(map(resp => resp.results.length > 0
          ? resp.results.map(x => ({ id: x.id, text: x.districtName })) : [{ id: null, text: 'Không có dữ liệu' }]));
        if (!this.DistrictSubscription) {
          this.DistrictSubscription = this.DistrictControl.valueChanges.subscribe(() => {
            this.utilService.bindOrUnBindTheId(this.commonFilter, 'DistrictId', this.DistrictControl.value);
          });
        }
      });
     
      //get quận huyện
      this.districtService.getSelectPagingDistrictById(this.currentUser.districtId).subscribe(response => {
        this.DistrictControl.setValue({ id: response.id, text: response.districtName });
      });
    }
    if (this.currentUser.accountType === 1) {
      this.disProvincesService.getSelectPagingProvinceById(this.currentUser.provinceId).subscribe(res => {
        this.DisProvincesControl.setValue({ id: res.id, text: res.provinceName });
        
        this.getDistrictACFn = (value: any) => this.districtService.getDistrictSelectPaging({
          searchTerm: value, ProvinceId: this.currentUser.provinceId, PageIndex: 1, PageSize: 100
        }).pipe(map(resp => resp.results.length > 0
          ? resp.results.map(x => ({ id: x.id, text: x.districtName })) : [{ id: null, text: 'Không có dữ liệu' }]));
        if (!this.DistrictSubscription) {
          this.DistrictSubscription = this.DistrictControl.valueChanges.subscribe(() => {
            this.utilService.bindOrUnBindTheId(this.commonFilter, 'DistrictId', this.DistrictControl.value);
          }); 
        }
      }); 
    }
    if (this.currentUser.accountType === 1) {
      this.commonFilter.subordinateTypeId = this.currentUser.eadId;
    } else {
      this.commonFilter.subordinateTypeId = 0;
    }
    if (this.currentUser.accountType === 2) {
      this.disProvincesService.getSelectPagingProvinceById(this.currentUser.provinceId).subscribe(res => {
        this.DisProvincesControl.setValue({ id: res.id, text: res.provinceName }); 
        this.getDistrictACFn = (value: any) => this.districtService.getDistrictSelectPaging({
          searchTerm: value, ProvinceId: this.currentUser.provinceId, PageIndex: 1, PageSize: 100
        }).pipe(map(resp => resp.results.length > 0
          ? resp.results.map(x => ({ id: x.id, text: x.districtName })) : [{ id: null, text: 'Không có dữ liệu' }]));
        if (!this.DistrictSubscription) {
          this.DistrictSubscription = this.DistrictControl.valueChanges.subscribe(() => {
            this.utilService.bindOrUnBindTheId(this.commonFilter, 'DistrictId', this.DistrictControl.value);
          });
        } 
        this.districtService.getSelectPagingDistrictById(this.currentUser.districtId).subscribe(response => {
          this.DistrictControl.setValue({ id: response.id, text: this.currentUser.eadName });
          this.reload();
        });
      });
      
    }
    this.reload();
    this.maxHeight = window.innerHeight;
    this.authQuery.userSetting$.subscribe((type) => {
      if (type) {
        this.btnType = type.btnType;
      }
    });
    this.loadDisProvinces();
    this.loadTypeOfDisability();
  }
  changeYear() {
    this.commonFilter.year = this.year;
  }

  reload() {
    const _this = this;
    this.loading = true;
    _this.dataTable = [];
    _this.dataHeader1 = [];
    if (this.commonFilter.AgeId === null) {
      delete this.commonFilter.AgeId;
    }
    this.resetData();
    this.service.getRpKsDktNktDt(this.commonFilter).pipe(takeUntil(this.$unSubcsribe)).subscribe(
      (response: any) => {
        if (response.data === null && response.pivotDt === null) {
          _this.dataTable = [];
        } else {
          this.resetData();
          this.handlingData(response);
          this.dataTable = response.data;
          this.width = 210 + (100 * this.keyIdArr.length);
        }
        _this.loading = false;
      }, () => {
        _this.dataTable = [];
        _this.loading = false;
      }
    );
  }
  handlingData(response?: any) {
    /*dataHeaderRow1 - du lieu header 1*/
    if (response.data != null && response.pivotDt != null) {
      response.pivotDt.forEach(dm => {
        this.keyIdArr.push(dm.dataKey);
        this.dataHeader1.push({ 'rowSpan': 1, 'colSpan': 1, 'dataName': dm.dataName });
      });
    }
  }

  exportExcel() {
    if (this.commonFilter.AgeId === null) {
      delete this.commonFilter.AgeId;
    }
    this.service.exportRpKsDktNktDt(this.commonFilter).subscribe((data) => {
      const downloadURL = window.URL.createObjectURL(data);
      const link = document.createElement('a');
      link.href = downloadURL;
      link.download = 'DangTatTheoNhomTuoi.xlsx';
      link.click();
    });
  }
  search() {
    this.reload();
  }
  resetData() {
    this.dataTable = [];
    this.keyIdArr = [];
  }

  ngAfterViewInit() {
    setTimeout(() => { this.checkCaculateSize(); }, 500);
    // keyboard
    this.shortcuts.push({ key: ['alt + n'], label: 'Help', description: 'Cmd + b', command: () => console.log('alt + n'), preventDefault: true });
    this.cdRef.detectChanges();
  }
  isDivisibleForFour(index: number) {
    if (index % 4 === 0) {
      return true;
    } else {
      return false;
    }
  }
  checkCaculateSize() {
    setTimeout(() => {
      this.height = this.heightfnc();
      this.width = 210 + (100 * this.keyIdArr.length);
    }, 1);
  }
  heightfnc() {
    return this.sizePageService.caculateHeight(
      this.elementpageOptionBtnGroup,
      this.elementPageSearch,
      this.elementPageHeaderTable
    );
  }
  caculateHeightPopup(maxHeight: number): number {
    let heightModal: number;
    if (maxHeight > 950) {
      return (heightModal = 700 + (maxHeight - 860));
    } else {
      return (heightModal = 700 - (860 - maxHeight));
    }
  }
  onResize() {
    this.checkCaculateSize();
  }
  toggleCollapse(): void {
    this.maxHeight = window.innerHeight;
    this.isCollapse = !this.isCollapse;
    this.checkCaculateSize();
    // this.height = 100;
  }

  // tslint:disable-next-line: adjacent-overload-signatures
  loadDisProvinces() {
    // tslint:disable-next-line: max-line-length
    this.getDisProvincesACFn = (value: any) => this.disProvincesService.getProvinceSelectPaging({
      searchTerm: value, PageIndex: 1, PageSize: 100
    }).pipe(map(resp => resp.results.length > 0
      ? resp.results.map(x => ({ id: x.id, text: x.provinceName })) : [{ id: null, text: 'Không có dữ liệu' }]));
    // tslint:disable-next-line: max-line-length
    if (!this.DisProvincesSubscription) {
      this.DisProvincesSubscription = this.DisProvincesControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.commonFilter, 'ProvinceId', this.DisProvincesControl.value);
      });
    }
  }
  // tslint:disable-next-line: adjacent-overload-signatures
  changeDisProvincesACFn(control: FormControl) {
    this.DisProvincesControl = control;
    if (this.DisProvincesControl) {
      this.loadDistrict();
      this.DistrictControl.setValue(null);
    }
  }
  loadDistrict() {
    // tslint:disable-next-line: max-line-length
    this.getDistrictACFn = (value: any) => this.districtService.getDistrictSelectPaging({
      searchTerm: value, ProvinceId: this.valueIfHas(this.DisProvincesControl), PageIndex: 1, PageSize: 100
    }).pipe(map(resp => resp.results.length > 0
      ? resp.results.map(x => ({ id: x.id, text: x.districtName })) : [{ id: null, text: 'Không có dữ liệu' }]));
    // tslint:disable-next-line: max-line-length
    if (!this.DistrictSubscription) {
      this.DistrictSubscription = this.DistrictControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.commonFilter, 'DistrictId', this.DistrictControl.value);
      });
    }
  }
  // tslint:disable-next-line: adjacent-overload-signatures
  changeDistrictACFn(control: FormControl) {
    this.DistrictControl = control;
    if (this.DistrictControl) {
      this.loadWard();
      this.WardControl.setValue(null);
    }
  }

  loadWard() {
    // tslint:disable-next-line: max-line-length
    this.getWardACFn = (value: any) => this.wardService.getWardSelectPaging({
      searchTerm: value, DistrictId: this.valueIfHas(this.DistrictControl), PageIndex: 1, PageSize: 100
    }).pipe(map(resp => resp.results.length > 0
      ? resp.results.map(x => ({ id: x.id, text: x.wardName })) : [{ id: null, text: 'Không có dữ liệu' }]));
    // tslint:disable-next-line: max-line-length
    if (!this.WardSubscription) {
      this.WardSubscription = this.WardControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.commonFilter, 'WardId', this.WardControl.value);
      });
    }
  }
  // tslint:disable-next-line: adjacent-overload-signatures
  changeWardACFn(control: FormControl) {
    this.WardControl = control;
  }

  loadTypeOfDisability() {
    this.getTypeOfDisabilityACFn = (value: any) => this.typeOfDisabilityService.getSelectPaging({
      searchTerm: value, PageIndex: 1, PageSize: 100
    }).pipe(map(resp => resp.results.length > 0
      ? resp.results.map(x => ({ id: x.id, text: x.typeOfDisabilityName })) : [{ id: null, text: 'Không có dữ liệu' }]));
    if (!this.TypeOfDisabilitySubscription) {
      this.TypeOfDisabilitySubscription = this.TypeOfDisabilityControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.commonFilter, 'TypeOfDisabilityId', this.TypeOfDisabilityControl.value);
      });
    }
  }
  changeTypeOfDisability(control: FormControl) {
    this.TypeOfDisabilityControl = control;
  }

  valueIfHas(control: FormControl) {
    if (control.value && typeof control.value !== 'string') { return control.value.id; }
    return '';
  }
  clear() {
    this.DisProvincesControl.setValue(null);
    this.DistrictControl.setValue(null);
    this.WardControl.setValue(null);
    this.TypeOfDisabilityControl.setValue(null);
    delete this.commonFilter.AgeId;
    this.reload();
  }
  ngOnDestroy(): void {
    this.$unSubcsribe.next();
    this.$unSubcsribe.complete();
}
}
